export default "__VITE_ASSET__CugfAQTM__"